import React from "react";
import "./Solar_Insights.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { SolarInsights } from "../../../utils/apis/homepage/index";
import { Blog } from "../../../utils/apis/blog/Blog";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";

const Solar_Insights = () => {
  const navigate = useNavigate();
    const handleServiceClick = (id) => {
      navigate(`/blog/${id}`);
    };
  const blogData = [
    {
      id: 1,
      image: "/assets/images/home/solar_insights/img-1.png",
      author: "Shreya mishra",
      date: "10 Oct 2024",
      title: "Why Solar Energy Is the Smartest Investment for Indian Homes",
      desc:
        "Discover how residential solar systems help homeowners reduce electricity bills, increase property value, and...",
    },
    {
      id: 2,
      image: "/assets/images/home/solar_insights/img-1.png",
      author: "Shreya mishra",
      date: "10 Oct 2024",
      title: "Why Solar Energy Is the Smartest Investment for Indian Homes",
      desc:
        "Discover how residential solar systems help homeowners reduce electricity bills, increase property value, and...",
    },
    {
      id: 3,
      image: "/assets/images/home/solar_insights/img-1.png",
      author: "Shreya mishra",
      date: "10 Oct 2024",
      title: "Why Solar Energy Is the Smartest Investment for Indian Homes",
      desc:
        "Discover how residential solar systems help homeowners reduce electricity bills, increase property value, and...",
    },
    {
      id: 4,
      image: "/assets/images/home/solar_insights/img-1.png",
      author: "Shreya mishra",
      date: "10 Oct 2024",
      title: "Why Solar Energy Is the Smartest Investment for Indian Homes",
      desc:
        "Discover how residential solar systems help homeowners reduce electricity bills, increase property value, and...",
    },
    {
      id: 5,
      image: "/assets/images/home/solar_insights/img-1.png",
      author: "Shreya mishra",
      date: "10 Oct 2024",
      title: "Why Solar Energy Is the Smartest Investment for Indian Homes",
      desc:
        "Discover how residential solar systems help homeowners reduce electricity bills, increase property value, and...",
    },
  ];

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();


  const { IMG_URL } = useContext(Context);
  
    const [solarinsight, setSolarInsight] = useState([]);
  
    const getSolarInsights = async () => {
      const res = await SolarInsights();
      if (res?.success) {
        setSolarInsight(res.data);
      }
    };
    useEffect(() => {
      getSolarInsights();
    }, []);

  return (
    <section className="Solar_Insights">
      <div className="container">
        <div className="Solar_Insights_header_holder">
          <h5 className="Solar_Insights_header">
            Solar Insights & Industry Updates
          </h5>
          <p className="Solar_Insights_subtitle">
            Expert knowledge, latest trends, and practical tips to help you make
            smarter solar decisions.
          </p>
        </div>
        <div className="blog_grid">
          {solarinsight.slice(0, 6).map((blog) => (
            <div
              key={blog.id}
              className={`blog_card ${
                blog.id <= 2 ? "blog_card_large" : "blog_card_small"
              }`}
              style={{ backgroundImage: `url(${IDS?.IMG_URL}${blog?.image})` }}
              onClick={() => handleServiceClick(blog.id)}
            >
              <div className="blog_overlay">
                <div className="blog_meta">
                  <FontAwesomeIcon icon={faUser} style={{ color: "#fff" }} />
                  <span className="author_name">{blog.name}</span>
                  <span className="date">- {new Date(blog.createdAt).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })}</span>
                </div>

                <h3 className="blog_title">{blog.title}</h3>
                <p className="blog_desc">{htmlToReactParser.parse(blog.description)}</p>

                <a href="#" className="read_more">
                  Read more
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="view_all_section">
          <div className="view_line"></div>
            <button className="view_all_btn" onClick={() => navigate("/blog")}>
              View all
            </button>
        </div>
      </div>
    </section>
  );
};

export default Solar_Insights;
